function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39.06 19.159c0 9.007-5.405 11.86-12.073 11.86-6.667 0-12.072-2.853-12.072-11.86s5.405-16.31 12.072-16.31c6.668 0 12.073 7.303 12.073 16.31z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.67 21.63a2.683 1.341 0 11-5.366 0 2.683 1.341 0 115.366 0z",
  strokeWidth: 0.999343
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.963 26.995c4.024 1.342 4.024-4.024 4.024-4.024 0 2.683 1.303 4.523 4.024 4.024"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.768 15.593a.67.67 0 11-1.342 0 .67.67 0 111.342 0zM31.28 15.593a.67.67 0 11-1.342 0 .67.67 0 111.342 0z",
  strokeWidth: 0.999343
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.695 3.659S16.476.475 14.579 1.452c-4.742 2.442-9.85 15.746-5.03 13.47 3.018-1.424 3.27-4.792 5.03-7.253 1.76-2.461 4.024-1.036 4.024-1.036M32.448 4.237S38.696.32 41 1.49c5.759 2.921 11.961 18.838 6.108 16.115-3.665-1.704-3.97-5.733-6.108-8.677-2.138-2.945-4.887-1.24-4.887-1.24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.28 29.678v20.121s-3.076-.163-4.024 2.683c-1.341 4.024 9.39 4.024 9.39 0 0-6.84 1.341-13.414 1.341-13.414M33.578 29.678v20.121s3.076-.163 4.024 2.683c1.342 4.024-9.39 4.024-9.39 0 0-6.84-1.225-13.414-1.225-13.414",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.012 29.678c-10.082 3.237-7.918 10.763-6.439 20.121 0 0-6.707.447-6.707 2.683 0 4.024 9.39 1.341 9.39 1.341M33.694 29.678c10.082 3.237 8.187 10.763 6.707 20.121 0 0 6.439.447 6.439 2.683 0 4.024-9.39 1.341-9.39 1.341"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.232 37.726c-5.62-2.729-6.938-8.24-6.707-14.755 2.26 4.689 5.282 8.93 9.926 8.853",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgDog = function SvgDog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dog.cff5edbd.svg";
export { ForwardRef as ReactComponent };